import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import * as apicall from "../../components/Apicall";

// Plain, read-only "who didn't pay" view for team members who aren't the
// vendor owner or on the Support team — sourced directly from `bookings`
// (leads/unpaid-bookings), deliberately not the ezp_leads/lead-work-item
// pipeline, which is reserved for Lead Management access.
const today = new Date().toISOString().split("T")[0];

const formatDateTime = (value) =>
  value
    ? new Date(value).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "numeric", minute: "2-digit" })
    : "—";

const UnpaidBookingsView = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);

  const fetchRows = async () => {
    try {
      setLoading(true);
      const res = await apicall.get(`leads/unpaid-bookings?startDate=${startDate}&endDate=${endDate}`);
      setRows(res?.data || []);
    } catch (err) {
      toast.error("Failed to load unpaid bookings: " + err.message);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRows();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  return (
    <div style={{ padding: "28px 32px", minHeight: "100vh", background: "#F8FAFC" }}>
      <div className="mb-4">
        <h1 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: 22, color: "#111827", margin: "0 0 4px" }}>Unpaid Bookings</h1>
        <p style={{ fontSize: 13, color: "#6B7280", margin: 0 }}>
          Bookings where payment wasn't completed — {rows.length} in range
        </p>
      </div>

      <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E5E7EB", padding: "14px 20px", marginBottom: 18, display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap", boxShadow: "0 1px 3px rgba(0,0,0,0.04)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 12.5, color: "#6B7280", fontWeight: 500 }}>From</span>
          <input type="date" className="form-control" value={startDate} onChange={(e) => setStartDate(e.target.value)} style={{ height: 38, fontSize: 13, borderRadius: 8, border: "1px solid #E5E7EB", background: "#F9FAFB", width: 150 }} />
          <span style={{ fontSize: 12.5, color: "#6B7280", fontWeight: 500 }}>To</span>
          <input type="date" className="form-control" value={endDate} onChange={(e) => setEndDate(e.target.value)} style={{ height: 38, fontSize: 13, borderRadius: 8, border: "1px solid #E5E7EB", background: "#F9FAFB", width: 150 }} />
        </div>
      </div>

      <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E5E7EB", overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
        <div style={{ overflowX: "auto", overflowY: "auto", maxHeight: 560 }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13, minWidth: 700 }}>
            <thead>
              <tr style={{ background: "#F8FAFC", borderBottom: "1px solid #E5E7EB", position: "sticky", top: 0, zIndex: 1 }}>
                {["Booking ID", "Customer", "Mobile Number", "Service", "Amount", "Booked At"].map((h) => (
                  <th key={h} style={{ padding: "12px 16px", textAlign: "left", fontWeight: 600, color: "#374151", fontSize: 11.5, textTransform: "uppercase", letterSpacing: "0.05em", whiteSpace: "nowrap", borderRight: "1px solid #F3F4F6" }}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={6} style={{ textAlign: "center", padding: "52px 0", color: "#9CA3AF" }}>Loading…</td></tr>
              ) : rows.length === 0 ? (
                <tr><td colSpan={6} style={{ textAlign: "center", padding: "52px 0", color: "#9CA3AF" }}>No unpaid bookings in this range</td></tr>
              ) : (
                rows.map((row) => (
                  <tr key={row.booking_id} style={{ borderBottom: "1px solid #F3F4F6" }}>
                    <td style={{ padding: "12px 16px", borderRight: "1px solid #F3F4F6", color: "#374151" }}>{row.booking_id}</td>
                    <td style={{ padding: "12px 16px", borderRight: "1px solid #F3F4F6", fontWeight: 600, color: "#111827" }}>{row.first_name}</td>
                    <td style={{ padding: "12px 16px", borderRight: "1px solid #F3F4F6", color: "#374151" }}>{row.phone_number}</td>
                    <td style={{ padding: "12px 16px", borderRight: "1px solid #F3F4F6", color: "#374151" }}>{row.service_name}</td>
                    <td style={{ padding: "12px 16px", borderRight: "1px solid #F3F4F6", color: "#374151" }}>{row.cart_value != null ? `₹${row.cart_value}` : "—"}</td>
                    <td style={{ padding: "12px 16px", color: "#374151" }}>{formatDateTime(row.created)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default UnpaidBookingsView;
